export default function ToolTip({ toolTipTitle, toolTipText }) {
  return (
    <div className="tooltip-wrapper">
      <button type="button" className="info-btn">
        i
      </button>

      <div className="tooltip-box">
        <h3>{toolTipTitle}</h3>
        <p>{toolTipText}</p>
      </div>
    </div>
  );
}
